export default "__VITE_ASSET__qxNsI_Hr__"